import {
  handleLinkByTypeV2,
  handleLinkLocale,
} from "@/helpers/common/handleLinkByType";
import { useRouter } from "next/router";
import Link from "next/link";
import { handleStartWithSlashInUrl, validateImgSrc } from "@/utils/global";
import { v4 as uuidv4 } from "uuid";
import NextImage from "../global/NextImage";
import { banner_clicked_event } from "@/utils/gtm";

const StaticBanners = ({ data }) => {
  console.log("StaticBannersdata", data);
  const { locale, push } = useRouter();

  return data?.value?.length ? (
    <section className="grid w-11/12 grid-cols-1 gap-8 mx-auto my-4 max-sm:gap-2 sm:my-8 md:grid-cols-2">
      {data?.value?.map((banner) => {
        const url = handleLinkLocale(banner?.url, locale);
        return (
          <div
            key={uuidv4()}
            onClick={() => {
              push(
                handleLinkByTypeV2(handleStartWithSlashInUrl(url), banner?.type)
              );
              banner_clicked_event(banner, locale);
            }}
            className="w-full h-auto cursor-pointer"
          >
            <div className="relative overflow-hidden group block">
              <NextImage
                src={validateImgSrc(banner[`img-${locale}`])}
                priority={data?.position === "4" ? true : false}
                className="w-full h-auto transition-all duration-500 group-hover:scale-110"
                alt={banner[`title-${locale}`]}
                title={banner[`title-${locale}`]}
                width={500}
                height={500}
              />

              <div className="absolute top-0 z-20 flex flex-col items-center justify-center w-full h-full gap-4 p-4 text-white start-0 ">
                <p className="font-bold text-center uppercase max-w-52 sm:max-w-[65%] sm:text-[28px] sm:leading-relaxed block">
                  {banner[`title-${locale}`]}
                </p>
                {banner[`button-text-${locale}`] && (
                  <Link
                    href={handleLinkByTypeV2(
                      handleStartWithSlashInUrl(url),
                      banner?.type
                    )}
                    className="block text-center w-40 py-2 text-lg font-bold uppercase transition-all ease-linear rounded-sm max-sm:text-xs bg-primary hover:bg-none hover:border hover:border-white hover:text-white"
                  >
                    {banner[`button-text-${locale}`]}
                  </Link>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </section>
  ) : null;
};

export default StaticBanners;
